import {
    graphql
} from 'react-relay'


const query = graphql`
    query getAllUnityQuery ($pagination: PaginationInput, $sorts: [OrderInput!], $where: JSON) {
        getAllUnity (pagination: $pagination, sorts: $sorts, where: $where) {
            count,
            items {
                id
                name
                code
                createdAt
                updatedAt
            }
      }
    }
  `

  export default query;